import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { MenuItemGroup } from '@/models/metadata';
import { CustomerProfile, Menu } from '@/models';

@Component({
  name: 'CmgMealBuilderHeader',
})
export default class CmgMealBuilderHeader extends Vue {
  @Prop({ required: true, type: Object })
  group!: MenuItemGroup;

  @Prop({ required: false, type: Object })
  selectedQuantityGroup?: MenuItemGroup;

  @Prop({ required: true, type: Object })
  menu!: Menu;
  
  get displayName(): string {
    return this.group.type == 'quantity' && this.selectedQuantityGroup ? this.selectedQuantityGroup.description : this.group.displayName;
  } 

  get bannerImageUrl(): string {
    return this.group.type == 'quantity' && this.selectedQuantityGroup ? this.selectedQuantityGroup.bannerImageUrl : this.group.bannerImageUrl;
  }

  get customerProfile(): CustomerProfile | null {
    return this.$appStore.state.customer.profile;
  }

  @Watch('customerProfile', { immediate: true })
  async onCustomerProfileChanged(customerProfile: CustomerProfile | null) {
    if (!customerProfile) {
      return;
    }

    await this.$services.recentAndFavoriteOrders.refreshRecentOrders();
  }
}
